export default {
  methods: {
    /**
     * バリデーションを実行し、エラーがあればエラーメッセージがあるフィールドにスクロールする
     * ValidationObserverにはref="observer"を設定しておくことが必要
     * @param {boolean} showErrorMessage
     * @param {string} errorToastMessage 
     * @returns 
     */
    async validateAndScroll(showErrorToast = false, errorToastMessage = '入力内容に不備があります。ご確認の上再度実行してください。') {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        return true
      }
      const ref = Object.values(this.$refs.observer.refs)
        .filter((ref) => ref.errors.length > 0)[0]
      ref.$el.scrollIntoView({ behavior: 'smooth', block: 'center'})
      if (showErrorToast) {
        this.$store.commit('notify/set', {message: errorToastMessage, type: 'danger'})
      }
      return isValid
    },
    /**
     * バリデーションを実行し、エラーがなければ onSuccess を実行する
     * ValidationObserverにはref="observer"を設定しておくことが必要
     * @param {Function} onSuccess
     * @param {boolean} showErrorMessage
     * @param {string} errorToastMessage 
     * @returns 
     */
    async customPasses(onSuccess, showErrorToast = false, errorToastMessage = '入力内容に不備があります。ご確認の上再度実行してください。') {
      const isValid = await this.validateAndScroll(showErrorToast, errorToastMessage)
      if (isValid) {
        onSuccess()
      }
    }
  }
}